import { elementController } from '@public-pages/runtime-core';

elementController('tabs', ({ query, queryAll }) => {
  const tabsContainer = query('[data-tabs-container]') as HTMLElement | null;
  const tabTitles = queryAll('[data-item]') as HTMLElement[];
  const tabPanels = queryAll('.tabs__item-description[data-item]') as HTMLElement[];

  if (!tabsContainer || tabTitles.length === 0 || tabPanels.length === 0) return;

  let activeIndex = 0;

  const updateUI = (index: number) => {
    tabTitles.forEach((title, i) => {
      const isActive = i === index;
      title.classList.toggle('active', isActive);
      title.classList.toggle('inactive', !isActive);
    });

    tabPanels.forEach((panel, i) => {
      const isActive = i === index;
      panel.classList.toggle('active', isActive);
      panel.classList.toggle('inactive', !isActive);
    });
  };

  const handleClick = (event: MouseEvent) => {
    const target = event.target as HTMLElement;
    const selectedTitle = target.closest('[data-item]') as HTMLElement | null;

    if (!selectedTitle) return;

    const index = tabTitles.findIndex((title) => title === selectedTitle);
    if (index !== -1 && index !== activeIndex) {
      activeIndex = index;
      updateUI(activeIndex);
    }
  };

  // Initialize active tab
  updateUI(activeIndex);

  // Add event listener
  tabsContainer.addEventListener('click', handleClick);

  // Cleanup
  return () => {
    tabsContainer.removeEventListener('click', handleClick);
  };
});
